import { useState } from "react";

import { GoAiguaButton, SearchBox } from "components/generic";
import GisTreeCreateNewNode from "components/adhoc/gistreecreatenewnode";
import ConfirmationDeleteGisHierarchy from "components/generic/confirmationdeletegishierarchy";
import EditNameGisHierarchy from "components/adhoc/editgishierarchy";
import GoAiguaModal from "components/generic/goaiguamodal";
import GisTreeStructureTable from "./gistreestructuretable.component";

import { useGisLayersTreeContext } from "storage/context/gis-layers-tree-hierarchy-context";
import {
    buttonIsActive,
    defineModalTitle,
} from "utils/gis-tree-hierarchy-functions";
import { useTranslation } from "utils/hooks/use-translation.hook";

import ToastRequestHandler from "./toast-request-handler";
import { makeGisTreeHierarchyFunctions } from "utils/components/gis-tree-hierarchy-functions";

export type ModalContentType =
    | "edit-modal"
    | "delete-modal"
    | "create-modal"
    | "";

const GisTreeHierarchy: React.FC = () => {
    const [textFilter, setTextFilter] = useState("");

    const [modalContentType, setModalContentType] =
        useState<ModalContentType>("");

    const translate = useTranslation();

    const {
        gisHierarchySelected,
        allContentIsReady,
        errorList,
        success,
        removeAllData,
        setGisHierarchySelected,
        loadHierarchiesById,
    } = useGisLayersTreeContext();

    const { closeModalFn, defineAddButtonStatus, openModalFn } =
        makeGisTreeHierarchyFunctions({
            gisHierarchySelected,
            setModalContentType,
        });

    return (
        <>
            <div className="c-tree-hierarchy">
                <div className="c-tree-hierarchy__header">
                    {translate("app.gis.hierarchy.groups_and_layers_tree")}
                </div>
                <div className="c-tree-hierarchy__search-buttons">
                    <div className="c-tree-hierarchy__search-buttons__input">
                        <SearchBox
                            placeholder={translate("app.hierarchy.search")}
                            value={textFilter}
                            className="c-tree-hierarchy__search-buttons__input"
                            onChange={(value) => setTextFilter(value)}
                        />
                    </div>
                    <div className="c-tree-hierarchy__search-buttons__options">
                        <GoAiguaButton
                            text={translate("app.hierarchy.add")}
                            className="c-tree-hierarchy__search-buttons__add-button"
                            onClick={() => openModalFn("create-modal")}
                            status={defineAddButtonStatus()}
                        />
                        <GoAiguaButton
                            text={translate("app.hierarchy.modify")}
                            className="c-tree-hierarchy__search-buttons__edit-button"
                            status={buttonIsActive(
                                "edit",
                                gisHierarchySelected,
                                modalContentType
                            )}
                            onClick={() => openModalFn("edit-modal")}
                        />
                        <GoAiguaButton
                            text={translate("app.Components.warning.delete")}
                            className="c-tree-hierarchy__search-buttons__delete-button"
                            onClick={() => openModalFn("delete-modal")}
                            status={buttonIsActive(
                                "delete",
                                gisHierarchySelected,
                                modalContentType
                            )}
                        />
                    </div>
                </div>
                <GisTreeStructureTable textFilter={textFilter} />
            </div>

            <GoAiguaModal
                headerTitle={defineModalTitle(
                    modalContentType,
                    translate,
                    gisHierarchySelected
                )}
                isOpen={modalContentType !== ""}
                setIsOpen={closeModalFn}
            >
                {modalContentType === "create-modal" ? (
                    <GisTreeCreateNewNode closeModalFn={closeModalFn} />
                ) : null}

                {modalContentType === "edit-modal" ? (
                    <EditNameGisHierarchy
                        gisHierarchySelected={gisHierarchySelected}
                        setGisHierarchySelected={setGisHierarchySelected}
                        loadHierarchiesById={loadHierarchiesById}
                        closeModalFn={closeModalFn}
                    />
                ) : null}

                {modalContentType === "delete-modal" ? (
                    <ConfirmationDeleteGisHierarchy
                        closeModalFn={closeModalFn}
                    />
                ) : null}
            </GoAiguaModal>

            <ToastRequestHandler
                allContentIsReady={allContentIsReady}
                closeToast={removeAllData}
                errorList={errorList}
                success={success}
            />
        </>
    );
};

export default GisTreeHierarchy;
